import { render, staticRenderFns } from "./PauseSubscription.vue?vue&type=template&id=5b4e0d97&"
import script from "./PauseSubscription.vue?vue&type=script&lang=js&"
export * from "./PauseSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports